import React from 'react';

const NavbarFiller = () => <>
  <div style={{height: '51px'}} />
</>

export default NavbarFiller;